import {
  Component,
  EventEmitter,
  Output,
  computed,
  inject,
  signal
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { map } from 'rxjs';
import { AcademicYearModel } from 'src/app/core/models/academic-year.model';
import { AcademicYearsStateService } from 'src/app/core/services/academic-years-state.service';

@Component({
  selector: 'liv-academic-years-filter',
  templateUrl: './academic-years-filter.component.html',
  styleUrls: ['./academic-years-filter.component.scss'],
  standalone: false
})
export class AcademicYearsRequestComponent {
  private readonly academicYearsService = inject(AcademicYearsStateService);

  @Output() selectAcademicYear = new EventEmitter<AcademicYearModel>();

  protected readonly expandFilterDropdown = signal(false);

  protected readonly academicYears = toSignal(
    this.academicYearsService.academicYears$.pipe(
      map((academicYears) =>
        academicYears.filter((academicYear) => academicYear.ativo_material)
      )
    ),
    { initialValue: [] as AcademicYearModel[] }
  );

  protected readonly isLoadingAcademicYears = toSignal(
    this.academicYearsService.isLoading$,
    { initialValue: false }
  );

  protected readonly selectedAcademicYear = toSignal(
    this.academicYearsService.selectedAcademicYear$,
    { initialValue: null as AcademicYearModel | null }
  );

  protected readonly hasManyAcademicYears = computed(
    () => this.academicYears().length > 1
  );

  protected readonly selectableAcademicYears = computed(() => {
    const selectedId = this.selectedAcademicYear()?.id;

    return this.academicYears().filter((year) => year.id !== selectedId);
  });

  handleSelectAcademicYear(year: AcademicYearModel): void {
    if (this.academicYearsService.selectedAcademicYearSnapshot === year) {
      return;
    }

    this.expandFilterDropdown.set(false);
    this.academicYearsService.persistSelected(year);
    this.selectAcademicYear.emit(
      this.academicYearsService.selectedAcademicYearSnapshot
    );
  }
}
